import { Stack } from "@mui/material";
import LiveMonitoringFilter from "../filters/LiveMonitoringFilter";
import LiveMonitoringTable from "../tables/LiveMonitoringTable";


function LiveMonitoring() {

    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <LiveMonitoringFilter />
            <LiveMonitoringTable></LiveMonitoringTable>
        </Stack>
    )
}

export default LiveMonitoring;